function getPages(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 4) return [1, 2, 3, 4, 5, "…", total];
  if (current >= total - 3) {
    return [1, "…", total - 4, total - 3, total - 2, total - 1, total];
  }
  return [1, "…", current - 1, current, current + 1, "…", total];
}

function TablePagination({
  page = 1,
  pageSize = 10,
  total = 0,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50],
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const safePage = Math.min(Math.max(1, page), totalPages);
  const from = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);
  const pages = getPages(safePage, totalPages);

  return (
    <div className="wd-pg">
      <div className="wd-pg-left">
        <span className="wd-pg-info">
          Showing <strong>{from}</strong>–<strong>{to}</strong> of{" "}
          <strong>{total}</strong>
        </span>
        {typeof onPageSizeChange === "function" ? (
          <label className="wd-pg-size">
            Rows
            <select
              className="form-select form-select-sm"
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
              {pageSizeOptions.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        ) : null}
      </div>

      <div className="wd-pg-btns" role="navigation" aria-label="Pagination">
        <button
          type="button"
          className="wd-pg-btn"
          disabled={safePage <= 1}
          onClick={() => onPageChange(1)}
          aria-label="First page"
        >
          «
        </button>
        <button
          type="button"
          className="wd-pg-btn"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
          aria-label="Previous page"
        >
          ‹
        </button>

        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="wd-pg-ellipsis">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              className={`wd-pg-btn${p === safePage ? " active" : ""}`}
              onClick={() => onPageChange(p)}
              aria-current={p === safePage ? "page" : undefined}
            >
              {p}
            </button>
          )
        )}

        <button
          type="button"
          className="wd-pg-btn"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(safePage + 1)}
          aria-label="Next page"
        >
          ›
        </button>
        <button
          type="button"
          className="wd-pg-btn"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(totalPages)}
          aria-label="Last page"
        >
          »
        </button>
      </div>
    </div>
  );
}

export default TablePagination;
